import { css } from "@emotion/react";
import { COLORS } from "stylesheets/emotion/vars";

const PRICE_HEADER_WIDTH = "3.25vw";

export const deSteegStyle = css`
    body {
        overflow-y: scroll;
        scrollbar-width: none;
        -ms-overflow-style: none;

        &::-webkit-scrollbar {
            width: 0;
            height: 0;
        }
    }

    .bannerAll {
        display: grid;
        grid-template-columns: auto auto auto;
    }

    .bannerBack {
        width: 17.5%;
        margin-top: 0.55vw;
        position: absolute;
        margin-left: 53.6%;
    }

    .bannerFront {
        width: 19%;
        margin-left: 27.3%;
        margin-top: 0.68vw;
        position: absolute;
    }

    .bannerLogo {
        width: 10vw;
        position: relative;
        margin-top: 0.1vw;
        margin-left: 112.2%;
        z-index: 1000;
        filter: drop-shadow(0vw 0.3vw 0.3vw #000);
    }

    @keyframes rotation {
        0% {
            transform: rotate(0deg) scale(0.5);
            opacity: 0.15;
        }
        5% {
            transform: rotate(180deg) scale(0.5);
            opacity: 0.3;
        }
        10% {
            transform: rotate(360deg) scale(0.5);
            opacity: 0.15;
        }
        100% {
            transform: rotate(360deg) scale(0.5);
            opacity: 0.15;
        }
    }

    @keyframes opacity {
        0% {
            opacity: 0.05;
        }
        50% {
            opacity: 0.2;
        }
        100% {
            opacity: 0.05;
        }
    }

    .menukaart {
        width: 98.5vw;
        height: 100vh;
        gap: 0.5vw;
        display: grid;
        padding-left: 0.5vw;
        padding-right: 1vw;
    }

    .menu {
        width: 100%;
        height: 45vw;
        margin-top: 2vw;
        padding-right: 0.25vw;
    }

    .backgroundShadow {
        background-color: transparent;
        border-radius: 0vw;
    }

    .info {
        display: flex;
        flex-direction: row-reverse;
        margin-right: 0.75vw;
    }

    .row {
        display: flex;
        align-items: center;
        background-color: transparent;
        border-bottom: 0.07vw solid white;
        height: 2.55vw;
        padding-inline: 0.5vw;
        padding-left: 1vw;
    }

    .row:nth-child(even) {
        background-color: rgba(255, 234, 0, 0.15);
    }

    .row:nth-child(odd) {
        background-color: rgba(68, 140, 58, 0.19);
    }

    .row:nth-last-child(1) {
        border-bottom-left-radius: 0.8vw;
        border-bottom-right-radius: 0.8vw;
        border-bottom: none;
    }

    .row:first-child {
        border-top-left-radius: 0.8vw;
        border-top-right-radius: 0.8vw;
    }

    .rowContent {
        display: flex;
        align-items: center;
    }

    .productkind {
        color: white;
        font-size: 0.5vw;
        margin-top: 0.1vw;
        width: 3vw;
        margin-left: 2vw;
    }

    .banner {
        width: 100%;
        margin-left: 8vw;
        margin-top: 1vw;
        position: relative;
    }

    .bannerAll {
        display: hidden;
        height: 5vh;
    }

    .bannerLogo {
        display: hidden;
    }

    .legendNew {
        display: none;
    }

    .pagebackground {
        background-color: #000;
        background-image: url("/images/pricelist/smokeBackground.gif");
        background-repeat: no-repeat;
        background-size: cover;
        width: 100vw;
        height: 100vh;
        overflow: hidden;
    }

    .pattern {
        background-image: url("/images/pricelist/deSteegLogoColor.png");
        background-repeat: no-repeat;
        background-size: 30% 35%;
        background-position: center;
        top: 0%;
        position: absolute;
        height: 100%;
        width: 100%;
        opacity: 0.2;
    }

    @font-face {
        font-family: "cordia";
        font-weight: normal;
        font-style: normal;
    }

    .logo {
        position: absolute;
        margin-left: 20%;
        margin-top: -5%;
        width: 20%;
        opacity: 0;
    }

    .marginTopTitle {
        margin-top: -5vw;
    }

    .title {
        font-size: 1.7vw;
        font-weight: bold;
        margin-top: 1.5vw;
        margin-bottom: 0.4vw;
        position: relative;
        color: white;
        text-shadow: 0 0 0.04vw #000000, 0 0 0.05vw ${COLORS.deSteegGlow}, 0 0 0.06vw ${COLORS.deSteegGlow},
            0 0 0.07vw ${COLORS.deSteegGlow2}, 0 0 0.08vw ${COLORS.deSteegGlow}, 0 0 0.09vw ${COLORS.deSteegGlow2};
        padding-left: 1vw;
    }

    .titleNotAtTop {
        font-size: 1.7vw;
        font-weight: bold;
        margin-top: 1vw;
        margin-bottom: 0.4vw;
        position: relative;
        color: white;
        text-shadow: 0 0 0.04vw #000000, 0 0 0.05vw ${COLORS.deSteegGlow}, 0 0 0.06vw ${COLORS.deSteegGlow},
            0 0 0.07vw ${COLORS.deSteegGlow2}, 0 0 0.08vw ${COLORS.deSteegGlow}, 0 0 0.09vw ${COLORS.deSteegGlow2};
        padding-left: 1vw;
    }

    .particles {
        position: absolute;
        margin-left: 50vw;
        width: 15.6vw;
    }

    .btn {
        position: absolute;
    }

    .kindBadge {
        height: 1vh;
        width: 1vw;
        margin-right: 0.6vw;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .nameStar {
        display: flex;
        padding-left: 0.2vw;
    }

    .priceGrid {
        display: flex;
        justify-content: center;
        margin-left: 0.25vw;
    }

    .nameprice {
        font-size: 1vw;
        text-transform: uppercase;
        color: white;
        font-weight: bold;
    }

    .description {
        font-size: 1vw;
        color: white;
        margin: 0 auto;
    }

    .kind {
        font-size: 0.3vw;
        position: relative;
        margin-left: -2vw;
        margin-top: 0.5vw;
        width: 5vw;
        color: white;
    }

    .priceContainer {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .price {
        font-size: 1vw;
        width: ${PRICE_HEADER_WIDTH};
        color: white;
        font-weight: bold;
        text-align: right;
    }

    .priceHeader {
        position: relative;
        font-size: 1.1vw;
        margin-top: -1.5vw;
        text-align: right;
        width: ${PRICE_HEADER_WIDTH};
        color: white;
        font-weight: bold;
    }

    .filler {
        flex-grow: 1;
    }

    .extraIcon,
    .flag {
        transform-origin: center;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding-left: 0.6vw;
        filter: drop-shadow(1px 1px 0.4px rgba(0, 0, 0, 1));
    }

    .extraIcon {
        transform: scale(1.3);
    }

    .flag {
        transform: scale(1.7);
    }

    .iconContainer {
        white-space: nowrap; /* Prevent icons from breaking onto a new line */
        display: inline-flex; /* Align icons in a row with the text */
        gap: 0.5vw;
        padding-left: 0.3vh;
    }

    .svg-inline--fa {
        margin-left: 1vw;
        margin-top: 0.4vw;
        font-size: 0.7vw;
    }
`;
